import { translationKey } from '../i18n';
import { localize, readAppLanguage } from '../i18n';
import SingleLineText from './ui/SingleLineText';
import React from 'react';
import { Box, Typography } from '@mui/material';
import WifiOffRoundedIcon from '@mui/icons-material/WifiOffRounded';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import AppButton from './ui/AppButton';
import { colors } from '../design/tokens';

export default function ConnectionRetryState({ onRetry, title = translationKey('잠시 연결이 안 돼요'), fullScreen = false }) {
    return (
        <Box role="alert" sx={{
            minHeight: fullScreen ? '100dvh' : 370,
            px: 3, py: 5,
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            textAlign: 'center', bgcolor: fullScreen ? colors.canvas : 'transparent',
        }}>
            <Box sx={{
                position: 'relative', width: 144, height: 144, mb: 3,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                borderRadius: '50%', bgcolor: '#fff7d5',
                boxShadow: '0 0 0 10px #fffdf3',
            }}>
                <Box sx={{
                    width: 88, height: 88, borderRadius: '28px', bgcolor: '#fff',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    boxShadow: '0 8px 24px rgba(138, 112, 0, 0.10)',
                    transform: 'rotate(-7deg)',
                }}>
                    <WifiOffRoundedIcon sx={{ fontSize: 43, color: colors.brandDark, transform: 'rotate(7deg)' }} />
                </Box>
                <Box sx={{ position: 'absolute', width: 10, height: 10, borderRadius: '50%', bgcolor: colors.brand, top: 11, right: 20 }} />
                <Box sx={{ position: 'absolute', width: 6, height: 6, borderRadius: '50%', bgcolor: '#e7ce73', bottom: 19, left: 12 }} />
            </Box>
            <SingleLineText component="h2" sx={{ fontSize: '1.32rem', lineHeight: 1.35, fontWeight: 800, color: colors.text, mb: 1, ...(readAppLanguage() !== 'ko' && { width: '100%', whiteSpace: 'normal', overflowWrap: 'anywhere' }) }}>
                {localize(title)}
            </SingleLineText>
            <Typography sx={{ fontSize: '0.96rem', lineHeight: 1.6, color: colors.textSecondary, mb: 3.5 }}>{localize("인터넷 연결을 확인한 뒤")}<br />{localize("다시 시도해 주세요.")}</Typography>
            <AppButton onClick={onRetry} startIcon={<RefreshRoundedIcon />} sx={{ minWidth: 174, minHeight: 52, borderRadius: '16px', boxShadow: '0 5px 14px rgba(138, 112, 0, 0.13)' }}>{localize("다시 시도")}</AppButton>
        </Box>
    );
}
